/** @format */

import React, { useState, useEffect } from 'react'

import { caseHomepageRightList, updateCaseHomepageRight, caseClearRedis } from '../../api'

import { Table, Button, Modal, Input, message } from 'antd'

import './index.less'
import { setUseProxies } from 'immer'

const typeMap = ['', '国外', '国内']

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const [recommendList, setRecommendList] = useState([])

  const [editData, setEditData] = useState()
  const [editCaseId, setEditCaseId] = useState()
  const [editWord, setEditWord] = useState()

  // status
  const [editVisible, setEditVisible] = useState(false)
  const [listLoading, setListLoading] = useState(false)

  useEffect(() => {
    if (editData) {
      setEditCaseId(editData.caseId)
      setEditWord(editData.recommendWord)
    }
  }, [editData])

  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '推荐位置',
      dataIndex: 'type',
      key: 'type',
      render: (text) => typeMap[text],
    },
    {
      title: '案例ID',
      dataIndex: 'caseId',
      key: 'caseId',
    },
    {
      title: '推荐语',
      dataIndex: 'recommendWord',
      key: 'recommendWord',
    },
    {
      title: '维护时间',
      dataIndex: 'showTime',
      key: 'showTime',
    },
    {
      title: '操作',
      dataIndex: '',
      key: 'operation',
      render: (t, d, index) => (
        <Button
          className='editBtn'
          onClick={() => {
            setEditData(d)
            setEditVisible(true)
          }}
        >
          编辑
        </Button>
      ),
    },
  ]
  useEffect(() => {
    reqRecommendList()
  }, [])

  const handleEdit = () => {
    if (!editCaseId || !editWord) {
      message.error('案例和推荐语都不可为空')
      return
    }
    if (editData) {
      setEditVisible(false)
      updateCaseHomepageRight({
        id: editData.id,
        caseId: editCaseId,
        word: editWord,
      })
        .then((res) => {
          if (res?.error?.code === 0) {
            message.success('修改成功')
          } else {
            message.error(res?.data)
          }
        })
        .finally(() => {
          reqRecommendList()
        })
    }
  }

  const reqRecommendList = () => {
    setListLoading(true)
    caseHomepageRightList()
      .then((res) => {
        if (res?.error?.code === 0) {
          setRecommendList(res?.data)
        }
      })
      .finally(() => {
        setListLoading(false)
      })
  }

  const handleCloseEditModal = () => {
    setEditVisible(false)
    setEditData(undefined)
  }

  return (
    <div className='caseHomeRecommendContainer'>
      <Table
        loading={listLoading}
        columns={columns}
        dataSource={recommendList}
        pagination={false}
      />
      <div className='clearRedisRow'>
        <Button type='danger' onClick={caseClearRedis}>立即更新上线</Button>
      </div>
      <Modal
        visible={editVisible}
        title={`${editData?.id}_${typeMap[editData?.type]}`}
        okText='保存'
        cancelText='取消'
        onOk={handleEdit}
        onCancel={handleCloseEditModal}
      >
        <div className='caseEditModalContainer'>
          <div className='editRow'>
            <div className='label'>案例ID：</div>
            <Input
              value={editCaseId}
              onChange={(e) => setEditCaseId(e.target.value)}
              className='value'
            />
          </div>
          <div className='editRow'>
            <div className='label'>推荐语：</div>
            <Input
              value={editWord}
              maxLength={35}
              onChange={(e) => setEditWord(e.target.value)}
              className='value'
            />
          </div>
          <div className='editRow'>
            <div className='flexall'></div>
            <Button
              className='clearBtn'
              type='danger'
              onClick={() => {
                setEditWord('')
                setEditCaseId('')
              }}
            >
              清空
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
function setListLoading(arg0: boolean) {
  throw new Error('Function not implemented.')
}

